import BackendService from "./BackendService";

class StorageService extends BackendService {
  constructor() {
    super("storage");
  }

  async uploadFile(file, assetType, additionalData = {}) {
    const apiUrl = `${this.baseUrl}upload/${assetType}`;
    const accessToken = this.getAccessToken();

    const formData = new FormData();

    formData.append("files", file);
    Object.keys(additionalData).forEach((key) => {
      formData.append(key, additionalData[key]);
    });

    const options = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      const { data } = await this.instance.post(apiUrl, formData, options);
      return data;
    } catch (error) {
      console.error("Error uploading files:", error);
      throw error;
    }
  }
}

export default StorageService;
